<template>
  <div class="market-ParkingCouponList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="parking:coupon:template:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建停车券</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    > 
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #discount="{ row }">{{row.discount }} </template>
      <template #validTime="{ row }">{{ row.validTime }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
      <template #operation="{ scope }">
        <auth-button auth="parking:coupon:template:update">
          <el-button type="text" v-if="scope.row.disable"  class="edit mr20"  @click="onEdit(scope.row)">编辑</el-button>
          <el-button v-if="!scope.row.disable" class="del" type="text" @click="onChangeStatus(scope.row)">停用</el-button>
          <el-button v-if="scope.row.disable" class="del" type="text" @click="onChangeStatus(scope.row)">启用</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import {api_putUpadteStatusParkingCoupon,api_getParkingCouponList } from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "marketParkingCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "停车券名称",
          placeholder: "请输入停车券名称",
          type: "input",
          key: "name",
        },
        {
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "mall",
          key: "mallIds",
        },
        {}
      ],
      form: {},
      tableThData: [
        { prop: "mallName", label: "商场名称", minWidth: "180", },
        { prop: "name", label: "停车券名称", minWidth: "110", },
        { prop: "discount", label: "抵扣优惠", minWidth: "110", },
        { prop: "validTime", label: "券有效时间", minWidth: "160", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getParkingCouponList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/market/parkingCouponList/add"
      });
    },
     // 点击编辑
    async onEdit(row) {
      this.$router.push({
        path: `/market/parkingCouponList/add?id=${row.id}`
      });
    },
    // 更改券状态
    onChangeStatus(row) {
      this.$baseConfirm(
         row.disable ? '是否确认启用该停车券？' : '是否停用该停车券？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_putUpadteStatusParkingCoupon({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-ParkingCouponList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .img {
    width: 50px;
    height: 50px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
